import Vue from 'vue'

/**
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 *
 */

export default () =>
  Vue.$http.post(`sinister/tasks/sendpendingemail/`)
